import {Component, Injector, linkedSignal, OnInit, signal} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ParticipantState, SessionRunParticipantStateType, SimUser} from "@models";
import {Translations} from "@translations";

export type DialogData_PeerPracticeParticipantDialogInput = MatDialogDataBaseInput & {
	participant: SimUser;
	subgroupName: string;
	stationIndex: number;
	roomName: string;
	confirmationOptions?: {participantState: SessionRunParticipantStateType};
};

@Component({
	selector: "sim-peer-practice-participant-dialog",
	standalone: false,
	templateUrl: "./peer-practice-participant-dialog.component.html",
	styleUrl: "./peer-practice-participant-dialog.component.scss",
})
export class PeerPracticeParticipantDialogComponent
	extends BasicMaterialDialog<PeerPracticeParticipantDialogComponent, DialogData_PeerPracticeParticipantDialogInput>
	implements OnInit
{
	// Properties
	protected readonly displayConfig = signal<DialogData_PeerPracticeParticipantDialogInput>(this.data);
	protected readonly isConfirmation = signal<boolean>(!!this.data.confirmationOptions);
	protected readonly participantState = linkedSignal<SessionRunParticipantStateType | undefined>(() =>
		this.isConfirmation() ? this.data.confirmationOptions?.participantState : undefined,
	);

	// Constants
	public readonly T = Translations;
	protected readonly ParticipantState = ParticipantState;
	protected readonly SessionRunParticipantStateType = SessionRunParticipantStateType;

	constructor(injector: Injector) {
		super(injector);
	}

	protected setParticipantState(value: SessionRunParticipantStateType) {
		alert(value);
	}
}
